import { deleteRequest, getRequest, postRequest, putRequest } from "../../../apiClient";
import { PriceSettingsEndpoint } from "../../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetPriceSettings = async (queryString: any) => {
    var _url = PriceSettingsEndpoint.PRICE_SETTINGS_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetModulesPriceSettings = async () => {
    var _url = PriceSettingsEndpoint.MODULES_PRICE_SETTINGS_URL;
    var res = await getRequest(_url);

    return res;
};

export const GetStoragesPriceSettings = async () => {
    var _url = PriceSettingsEndpoint.STORAGES_PRICE_SETTINGS_URL;
    var res = await getRequest(_url);

    return res;
};

export const GetUserTiersPriceSettings = async () => {
    var _url = PriceSettingsEndpoint.USER_TIERS_PRICE_SETTINGS_URL;
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const CreatePriceSettingService = async (param: any) => {
    var res = await postRequest(PriceSettingsEndpoint.PRICES_SETTINGS_URL, param);

    return res;
};
//#endregion